import { buildProps as e } from "./index601.js";
import { iconPropType as t } from "./index606.js";
const r = e({
  disabled: Boolean,
  currentPage: {
    type: Number,
    default: 1
  },
  pageCount: {
    type: Number,
    default: 50
  },
  nextText: {
    type: String
  },
  nextIcon: {
    type: t
  }
});
export {
  r as paginationNextProps
};
